import { CSSProperties, useEffect, useState } from "react";

const ButtonCtrl = ({ data, submit, back }: IControlBtn) => {

    const validate = (txt: string | undefined): boolean => (txt !== '' && txt !== undefined);
    const [css, setCss] = useState({} as CSSProperties);
    const css2Btn: CSSProperties = { display: "flex", justifyContent: "space-between" }
    const cssBtnLeft: CSSProperties = { display: "flex", justifyContent: "center" }
    const cssBtnRigth: CSSProperties = { display: "flex", justifyContent: " flex-end" }

    useEffect(() => {      
        if (validate(data.txtBtnBack) && validate(data.txtBtnNext))
            setCss(css2Btn)
        else if (validate(data.txtBtnBack))
            setCss(cssBtnLeft);
        else if (validate(data.txtBtnNext))
            setCss(cssBtnRigth);
    }, [data.txtBtnBack, data.txtBtnNext]);

    return (
        <div className="mt-20" style={css}>
            {validate(data.txtBtnBack) &&
                <button className="btn-auto-cr back-auto-cr" type="button" onClick={back}>{data.txtBtnBack}</button>
            }
            {validate(data.txtBtnNext) &&
                <button className="btn-auto-cr  next-auto-cr" type="button" onClick={submit}>{data.txtBtnNext}</button>
            }
        </div>
    );
}

export { ButtonCtrl };